import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpService } from '../shared/services/http.service';


@Injectable({
  providedIn: 'root'
})
export class HomeService {

  private countByStatus = 'api/member/dashboard/count';
  private quarterList = 'api/member/quarters';
  private themeList = 'api/member/themes';
  
  httpService = inject(HttpService);

  getCountByStatus(data: any, cat: string): Observable<any> {
      return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/dashboard/count`,data);
  }

  getQuarterList(data: any, cat: string): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/quarters`,data);
  }

  getthemeList(data: any, cat: string): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/themes`,data);
  }

  getOutcomesList(data: any, cat: string): Observable<any> {
    return this.httpService.post(`${environment.opbBackendHost}/api/${cat}/dashboard/list`,data);
  }


}
